import React, { useState } from 'react';
import { Card, Col } from 'react-bootstrap';
import useSearch from '../../hooks';
import Header from '../Common/Header';
import Searchfield from '../Common/Searchfield';
import CustomerList from './CustomersList';

const CustomerInfo = props => {
  const [showSearchField, setShowSearchField] = useState(false);

  const response = useSearch();

  function onSearchClear() {
    response.clearValue();
  }

  function onSearchChange(e) {
    response.setSearchValue(e.target.value);
  }

  function showOrHideSearchInput() {
    setShowSearchField(!showSearchField);
  }

  return (
    <>
      <Col md={12} sm={12} xs={12} className="p-2 custom-cards">
        <Card style={{ height: '100%' }}>
          <Header
            title={'Customers'}
            iconPosition="justify-content-end"
            iconProps={[
              {
                toolTipKEy: 'Search',
                toolTipValue: 'Search',
                icon: 'feather icon-search',
                onClickHandler: () => showOrHideSearchInput(),
                showIcon: true,
                cursor: 'pointer',
              },
            ]}
          />
          {showSearchField ? (
            <Searchfield
              inputValue={response.searchValue}
              inputChange={e => onSearchChange(e)}
              inputClear={onSearchClear}
            />
          ) : null}
          <CustomerList useSearch={response} selectedCustomerId={props.selectedCustomerId} />
        </Card>
      </Col>
    </>
  );
};

export default CustomerInfo;
